import { Flex } from "@chakra-ui/react";

export default function FormFieldCharactersRemaining({ currentValue, characterLimit }) {
  if (Number.isInteger(characterLimit)) {
    const remainingChar = currentValue ? characterLimit - currentValue?.trim().length : characterLimit;

    return (
      <Flex className='flip-in-hor-bottom' justify='flex-end' w='100%' color='gray.500' fontSize='0.65em'>
        {remainingChar} characters remaining
      </Flex>
    );
  }
}